import type { GroupNode, PipelineNode } from '@/mocks/pipeline';

export const NODE_W = 220;
export const NODE_H = 92;

export function nodeInGroup(node: { x: number; y: number }, g: GroupNode): boolean {
  const cx = node.x + NODE_W / 2;
  const cy = node.y + NODE_H / 2;
  return cx >= g.x && cx <= g.x + g.w && cy >= g.y && cy <= g.y + g.h;
}

export function buildRunSteps(nodes: PipelineNode[], groups: GroupNode[]): string[] {
  const memberIds = new Set<string>();
  groups.forEach((g) => {
    nodes.filter((n) => nodeInGroup(n, g)).forEach((n) => memberIds.add(n.id));
  });

  type Item = { y: number; x: number; expand: () => string[] };
  const items: Item[] = [];

  nodes
    .filter((n) => !memberIds.has(n.id))
    .forEach((n) => items.push({ y: n.y, x: n.x, expand: () => [n.id] }));

  groups.forEach((g) => {
    const members = nodes
      .filter((n) => nodeInGroup(n, g))
      .sort((a, b) => a.x - b.x)
      .map((n) => n.id);
    if (g.type === 'loop') {
      const count = Math.max(1, g.iterations || 1);
      items.push({ y: g.y, x: g.x, expand: () => Array.from({ length: count }, () => members).flat() });
    } else {
      items.push({ y: g.y, x: g.x, expand: () => members });
    }
  });

  items.sort((a, b) => a.y - b.y || a.x - b.x);
  return items.flatMap((it) => it.expand());
}